import {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import axios from 'axios';
import './Feedback.css';
import { useMsal } from "@azure/msal-react";

function getModalStyle() {
  const top = '20%';
  const left = '35%';

  return {    
    top: '25%',
    left: '38%',
    transform: `translate(-${top}%, -${left}%)`
  };
}

const useStyles = makeStyles((theme) => ({
  paper : {
    position : 'absolute',
    width: 420,
    backgroundColor: theme.palette.background.paper,    
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2,4,3)
  }
}));

export default function FeedbackContent() {
  const classes = useStyles();
  const [modalStyle] = useState(getModalStyle);
  const [open, setOpen] = useState(false);
  const [feedbackRes, setFeedbackRes] = useState('');  
  const [toggle, setToggle] = useState(true);
  const [comment, setComment] = useState('');
  const [feedbackBtn, setFeedbackBtn] = useState(true);
  const [taInlnStyle, setTaInlnStyle] = useState({height: "15px"});
  const [rating, setRating] = useState([]);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const handleOpen = () =>{
    setOpen(true);
    setToggle(true);
    setRating([]);
  }

  const handleClose = () =>{
    setOpen(false);
    setToggle(false);
  }  

  const closeFeedbackBtn = () => {
    setFeedbackBtn(false);
  }

  const handleComment = (commentVal) => {
        if(commentVal.length > 46 && commentVal.length < 92) {
            setTaInlnStyle({height: "45px"});            
        } else if(commentVal.length > 92) {
            setTaInlnStyle({height: "70px"});            
        }else if(commentVal.length < 46) {
            setTaInlnStyle({height: "21px"});
        }
        setComment(commentVal);
  }

  const handleSubmit = async (event) => {
      event.preventDefault();
      if(process.env.NODE_ENV === 'development') {                                                            
          alert("Not allowed to submit feedback from localhost.");
      }            
      else 
      {
          setToggle(false);
          axios.post('https://atci.lkm.accenture.com/lkm-apis/feedback', {
              enterprise_id: activeAccount.idTokenClaims.enterpriseID,
              rating: rating.length,                                                        
              comment: comment,
          },{
            headers: {              
              'Authorization': localStorage.getItem("token"),
              'Content-Type': 'application/json'
            }
          })
          .then((response) => {                        
              setFeedbackRes(response.data.message);
          })
          .catch((error)=>{
              setFeedbackRes(error.data.message);
          })                                                                          
          setComment('');
      }       
  }

  const body = (
    <div style={modalStyle} className={classes.paper}>            
      { toggle && <div id="feedback_form">
        <form onSubmit={handleSubmit}>
        <div className="feedback_label">
            Send Feedback 
        </div>
          <div className="feedback">             
            <span id="thankYou-close" onClick={handleClose}></span>
            <h6 className="question">Tell us your experience with the new L&TT Portal!</h6>                                                          
            <div className='feedback-rating'>
                <img src={rating.includes(1) ? "images/feedback/star_active.svg" : "images/feedback/star_inactive.svg"} alt="" onClick={()=>setRating([1])}/>
                <img src={rating.includes(2) ? "images/feedback/star_active.svg" : "images/feedback/star_inactive.svg"} alt="" onClick={()=>setRating([1,2])}/>
                <img src={rating.includes(3) ? "images/feedback/star_active.svg" : "images/feedback/star_inactive.svg"} alt="" onClick={()=>setRating([1,2,3])}/>
                <img src={rating.includes(4) ? "images/feedback/star_active.svg" : "images/feedback/star_inactive.svg"} alt="" onClick={()=>setRating([1,2,3,4])}/>
                <img src={rating.includes(5) ? "images/feedback/star_active.svg" : "images/feedback/star_inactive.svg"} alt="" onClick={()=>setRating([1,2,3,4,5])}/>            
                <p id="star-text" tabindex="0">{rating.length}/5</p>
            </div>                                  
            <textarea onChange={(event)=>{ handleComment(event.target.value) }} id="feedback-input" type="text" rows="2" placeholder="Please provide suggestions or feedback here" style={taInlnStyle}></textarea>
            <div className="submit">
              <button type="submit">Send</button>              
            </div>            
          </div>
        </form>
      </div>}  
      { !toggle && <div id="success_form">            
            <span id="thankYou-close" onClick={handleClose}></span>
            <h2 className="feedback-success">Thank you!</h2>                      
            <p className="feedback-success-msg">{feedbackRes}</p>                      
      </div> }                
    </div>        
  );

  return (
    <div>      
        {feedbackBtn && <div id="feedback-btn-newui" role="button"  aria-label="Feedback" class="keyboard-outline">
        <span role="button" class="feedback-lbl" onClick={handleOpen} tabindex="0">Feedback</span> 
        {/* <span role="button" class="feedback-btn-close" onClick={closeFeedbackBtn}></span> */}
    </div>}            
      <Modal open={open} aria-labelledby="simple-modal-tile" aria-describedby="simple-modal-description">
        {body}
      </Modal>        
    </div>   
  );
}